const config = {
  serverUrl: "https://api.theboxapp.gr"
};

module.exports = config;


// WEBPACK FOOTER //
// ./src/config.js